import {LogLevel, PublicClientApplication} from '@azure/msal-browser'

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AUTH_CLIENTID,
    authority: 'https://login.microsoftonline.com/42cc3295-cd0e-449c-b98e-5ce5b560c1d3',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return

        if (level === LogLevel.Error) {
          console.error(message)
        } else if (level === LogLevel.Warning) {
          console.warn(message)
        } else if (level === LogLevel.Verbose) {
          console.debug(message)
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read', 'offline_access'],
}

export const msalInstance = new PublicClientApplication(msalConfig)
